import { render, staticRenderFns } from "./BaseRouterView.vue?vue&type=template&id=8bba3452&scoped=true"
import script from "./BaseRouterView.vue?vue&type=script&lang=js"
export * from "./BaseRouterView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bba3452",
  null
  
)

export default component.exports